<template>
  <v-app>
    <v-main id="login" :class="{ 'white-bg': $vuetify.breakpoint.smAndDown }">
      <v-container fluid>
        <v-row justify="center" class="mt-9">
          <Logo />
        </v-row>
        <v-row justify="center">
          <v-col cols="12" xs="12" md="4" style="max-width: 400px;">
            <v-card class="card px-2 py-0 elevation-0">
              <MaintenanceCard v-if="maintenance" />

              <v-card-text v-else class="pa-7" :class="{ 'pt-1': $vuetify.breakpoint.smAndDown }">
                <SignMessage />
                <SignError :error="error" />

                <div
                  class="card-title pb-5"
                  :class="{
                    'dark_Textgrey--text': $vuetify.theme.dark,
                    'darkTextGrey--text': !$vuetify.theme.dark,
                  }"
                >
                  <p>{{ $t(`views.login.welcomeTitle`) }}</p>
                </div>

                <SignProviders :loading.sync="loading" @setErrorCode="(code) => (error = code)" />

                <v-form @submit.prevent="submit">
                  <v-text-field
                    v-model="email"
                    autofocus
                    :label="$t('views.login.email.label')"
                    name="email"
                    :prepend-icon="'mdi-email'"
                    type="text"
                    :placeholder="$t('views.login.email.placeholder')"
                    :disabled="loading"
                  />
                  <v-text-field
                    id="password"
                    v-model="password"
                    :label="$t('views.login.password.label')"
                    name="password"
                    :placeholder="$t('views.login.password.placeholder')"
                    :prepend-icon="'mdi-lock'"
                    type="password"
                    :disabled="loading"
                  />
                  <div>
                    <v-btn
                      type="submit"
                      color="primary"
                      :loading="loading"
                      class="elevation-0 submit-button mt-2"
                    >
                      {{ $t('views.login.continue') }}
                    </v-btn>
                  </div>
                </v-form>
                <div class="links mt-10">
                  <v-divider class="pt-4"></v-divider>
                  <p class="mb-1 pb-0">
                    <a
                      class="primary--text"
                      @click="!loading && $router.replace({ name: 'forgot' })"
                    >
                      {{ $t('views.login.cant') }}
                    </a>
                  </p>
                  <p class="links-signup">
                    <span
                      :class="{
                        'white--text': $vuetify.theme.dark,
                        'darkTextGrey--text': !$vuetify.theme.dark,
                      }"
                    >
                      {{ $t('views.login.signup1') }}
                    </span>
                    <a
                      class="primary--text"
                      @click="!loading && $router.replace({ name: 'signup' })"
                    >
                      {{ $t('views.login.signup2') }}
                    </a>
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-0">
          <LanguageSelector />
        </v-row>
        <v-row justify="center" class="my-5 mr-2">
          <ThemeSelector />
        </v-row>
      </v-container>
    </v-main>

    <dashboard-core-footer />
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
import SignMixin from '@/views/components/sign/signMixin.js'
import SignError from '@/views/components/sign/SignError'
import SignMessage from '@/views/components/sign/SignMessage'
import SignProviders from '@/views/components/sign/SignProviders'
import { getUser } from '@/lib/api.js'
import gtag from '../lib/gtag'

export default {
  components: {
    SignError,
    SignMessage,
    SignProviders,
  },
  mixins: [SignMixin],
  data: () => ({
    email: null,
    password: null,
  }),
  methods: {
    async submit() {
      await this.signIn()
    },
    async signIn() {
      this.loading = true
      let response
      try {
        response = await firebase.auth().signInWithEmailAndPassword(this.email, this.password)

        // TODO check firebaseUser.emailVerified -> is not verified, not enter
      } catch (error) {
        this.error = error.code || 'auth/wrong-password'
        this.loading = false

        gtag.pageview({
          pagePath: `/login/wrong-password`,
          pageTitle: `login|wrong-password`,
          pageContentGroup: 'page',
        })
        return
      }
      try {
        await getUser({ uid: response.user.uid })
      } catch (error) {
        if (error.status === 404) {
          return this.$router.replace({
            name: 'signup',
            query: { c: true, uid: response.user.uid },
          })
        }
        this.loading = false
      }
      await this.login()
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.white-bg {
  background-color: white !important;
}
.theme--dark {
  .white-bg {
    background-color: #1e1e1e !important;
  }
}
#login {
  // background: #f9fafc;
  // background: #fafafa;
  .card {
    text-align: center;
    .card-title {
      font-size: 20px;
      font-weight: 300;
    }
    .card-subtitle {
      font-size: 15px;
      font-weight: 300;
      text-align: justify;
      padding-bottom: 20px;
    }
    .submit-button {
      width: 100%;
    }
    .links {
      font-size: 14px;
      font-weight: 300;
      .links-signup {
        font-weight: 400;
      }
    }
  }
}
.theme--dark {
  #login {
    hr {
      border-color: #a5a5a5;
    }
  }
}
</style>
